export default {
  NOT_AVALIABLE : 1,
  PENDING : 2,
  APPROVE : 3,
}
